export default __webpack_public_path__ + "static/media/admin-bg.61f96dde.svg";